import { Title } from '@wyz/ui';
import { Trans } from '~/common/context';
import { COLLECTIONS } from '~/connect/schemas';
// eslint-disable-next-line @wyz/module/no-relative-import
import { ChangeLogsTable } from './change-logs-table';

export function DistributionPolicyLogsSection({
  customerGroupId,
}: {
  customerGroupId: string;
}) {
  return (
    <div className='mt-4'>
      <Title heading='page-title' weight='bold'>
        <Trans i18nKey='app.logs.history' />
      </Title>

      <ChangeLogsTable
        collection={COLLECTIONS.DistributionPricingPolicyExtraBonus}
        customerGroupId={customerGroupId}
        showTitle={false}
        showHeader={false}
      />
    </div>
  );
}
